import { render, staticRenderFns } from "./ReporteMarketing2.vue?vue&type=template&id=e797cb44&scoped=true"
import script from "./ReporteMarketing2.vue?vue&type=script&lang=js"
export * from "./ReporteMarketing2.vue?vue&type=script&lang=js"
import style0 from "./ReporteMarketing2.vue?vue&type=style&index=0&id=e797cb44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e797cb44",
  null
  
)

export default component.exports